import { Button } from 'antd';
import {
    DashboardOutlined, LineChartOutlined, HistoryOutlined, UploadOutlined, SettingOutlined, StopOutlined
} from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';

export default function HeaderTab({ currrentTab }) {

    const navigate = useNavigate();

    return (
        <div className='navbar_wraper_div'>
            <Button size='middle' onClick={() => {
                currrentTab !== "dashboard" && navigate("/")
            }} type={currrentTab === "dashboard" ? "primary" : ""} icon={<DashboardOutlined />}>
                Dashboard
            </Button>
            <Button size='middle' onClick={() => currrentTab !== "ranking" && navigate("/ranking")} type={currrentTab === "ranking" ? "primary" : ""} icon={<LineChartOutlined />}>
                Rankings
            </Button>
            <Button size='middle' onClick={() => {
                currrentTab !== "history" && navigate("/history");
            }} type={currrentTab === "history" ? "primary" : ""} icon={<HistoryOutlined />}>
                History
            </Button>
            <Button size='middle' onClick={() => currrentTab !== "uploadData" && navigate("/uploadData")} type={currrentTab === "uploadData" ? "primary" : ""} icon={<UploadOutlined />}>
                Upload Data
            </Button>
            <Button size='middle' onClick={() => currrentTab !== "excluded" && navigate("/excluded")} type={currrentTab === "excluded" ? "primary" : ""} icon={<StopOutlined />}>
                Excluded Items
            </Button>
            <Button size='middle' onClick={() => currrentTab !== "settings" && navigate("/settings")} type={currrentTab === "settings" ? "primary" : ""} icon={<SettingOutlined />}>
                Configuration
            </Button>
        </div>
    )
}
